import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { APIService } from '../../../providers/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from 'angular-2-local-storage';
import { DomSanitizer} from '@angular/platform-browser';
import { DetailsService } from '../../../providers/details.service';

@Component({
  selector: 'app-otpreceive',
  templateUrl: './otpreceive.component.html',
  styleUrls: ['./otpreceive.component.css']
})
export class OtpreceiveComponent implements OnInit {
  data: any;
  limitError = true;
  otpvalue: any;
  errormsg: any;
  registerForm: FormGroup;
  url: string;
  message: any;
  loginbg: any;
  youtubevideo: any;
  videoplay:boolean = false;
  siteURL:any;
  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private router: Router, public APIService: APIService, private localStorageService: LocalStorageService, private domSanitizer: DomSanitizer, public detailsService: DetailsService
    ) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.data = this.router.getCurrentNavigation().extras.state;
      // console.log('data', this.data.emailId);
    }
  }

  ngOnInit() {
    this.siteURL = this.localStorageService.get('siteUrl');
    if (this.siteURL == null) {
      const subdomain = window.location.hostname.split('.')[0];
      this.siteURL = `https://${subdomain}.statementgames.com`;
    }
    this.APIService.doApiCall((data:any) => {
       if (data.StatusCode == "SG001") {
         if(data.Data.youtubeLoginUrl != null){
         this.youtubevideo = data.Data.youtubeLoginUrl;
         if(this.youtubevideo !=  undefined && this.youtubevideo != '' && this.youtubevideo != null && this.youtubevideo != 'null'){
          let array2 = this.youtubevideo.split("?v=");
          if(array2.length == 1){
            this.youtubevideo = array2[0]
          }
          if(array2.length > 1){
            if(array2[1].includes('&')){
              let array3 = array2[1].split("&");
              this.youtubevideo = "https://www.youtube.com/embed/" + array3[0]
            }
             else{
              this.youtubevideo = "https://www.youtube.com/embed/" + array2[1]
             }
          }
           this.youtubevideo = this.domSanitizer.bypassSecurityTrustResourceUrl(this.youtubevideo);
         }
        }
       }
       else{
        this.youtubevideo = null;
       }

     }, 'api/organization/listbySiteUrl?siteUrl=' + this.siteURL, 'GET', null, null);
    this.loginbg = this.localStorageService.get('login_bg');
    this.loginbg = this.loginbg != null ? this.loginbg : '../../../../assets/img/register-bg.jpg';
    $('.loder1').hide();
    this.registerForm = this.formBuilder.group({
      otp1: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
      otp2: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
      otp3: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
      otp4: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
      otp5: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
      otp6: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]]
    });
  }

  userAvail1(otpvalue) {
    var self = this;
    if (otpvalue && otpvalue.length == 6) {
      this.limitError = false;
    } else {
      this.limitError = true;
    }
  }

  verifyOtp() {
    const self = this;
    // console.log('inside verifyotp');
    // tslint:disable-next-line:max-line-length
    const otpvalue = this.registerForm.value.otp1 + '' + this.registerForm.value.otp2 + '' + this.registerForm.value.otp3 + '' + this.registerForm.value.otp4 + '' + this.registerForm.value.otp5 + '' + this.registerForm.value.otp6;
    $('.loder').show();
    self.APIService.doApiCall(function (data) {
      $('.loder').hide();
      // console.log('verify token response', data);
      if (data.StatusCode == 'SG180') {
        self.errormsg = data.Message;

        setTimeout(() => {
          self.errormsg = '';
        }, 5000);
      } else if (data.StatusCode == 'SG182') {
        self.errormsg = data.Message;

        setTimeout(() => {
          self.errormsg = '';
        }, 5000);
      }
      if (data.StatusCode == 'SG001') {
        // Store user authentication data similar to successful login
        self.localStorageService.add('organizationId', data.organizationId);
        self.localStorageService.add('email', data.email);
        self.localStorageService.add('token', data.accessToken);
        self.message = 'SG Verficiation Code verified successfully';
        self.APIService.doApiCall(function (data) {
          self.localStorageService.add('roleId', data.Data.roleId);
          if (data.Data.roleId === self.detailsService.loginSuperAdmin) {
            self.localStorageService.add('loginas', "superadmin");
            self.localStorageService.add('admin_email',  self.localStorageService.get('email'));
          }
          else{
            self.localStorageService.add('loginas', undefined);
          }
          if (data.Data.roleId === self.detailsService.sgAdmin || data.Data.roleId === self.detailsService.loginSuperAdmin || data.Data.roleId === self.detailsService.clientAdmin) {
            self.localStorageService.add('reloadPage', true);
            self.router.navigate(['/dashboard/home']);
          } else if (data.Data.roleId === self.detailsService.loginUser) {
            self.localStorageService.add('isPushNotification', data.Data.isPushNotification)
            self.localStorageService.add('reloadPage', true);
            var compaignUrl = self.localStorageService.get('compaignUrl');
            if (compaignUrl) {
              window.location.href = self.localStorageService.get('newUrl') + '/user/lobby';
            }
            else {
              self.router.navigate(['/user/lobby']);
            }
          }
        }, 'api/profile/userinfo?email=' + data.email, 'GET', null, null);
      }

    }, 'api/user/otp/verify?token=' + otpvalue + '&emailId=' + self.data.emailId, 'GET', null, null);

  }

  resendOtp() {
    const self = this;
    // console.log('inside resend otp');
    $('.loder1').show();
    // $('.loder1').hide();
    self.APIService.doApiCall(function (data) {
      // console.log('resend response', data);
      $('.loder1').hide();
      if (data.StatusCode == 'SG001') {
        self.registerForm.setValue({
          otp1: '',
          otp2: '',
          otp3: '',
          otp4: '',
          otp5: '',
          otp6: '',
        });
        self.message = 'SG Verficiation Code sent to your registered email ID';
        setTimeout(() => {
          self.message = '';
        }, 5000);
      }
    }, 'api/user/otp/verifyPending?emailId=' + self.data.emailId, 'GET', null, null);
  }

  userAvail(ev, nextElement, previousElement) {
    if (ev.target.value.length == 1) {
      if (ev.target.value >= 0 && ev.target.value <= 9) {
        if (ev.target.value.match(/\s/g)) {
          ev.target.value = ev.target.value.replace(/\s/g, '');
        } else {
          nextElement.focus();
        }
      } else {
        // console.log('space');
        ev.target.value = '';
      }
    } else if (ev.target.value.length == 0) {
      /*  previousElement.value = ''; */
      previousElement.focus();

      // console.log('detected');

    }
    // console.log(ev.target.value);
    // console.log('space length', ev.target.value.length);
    // console.log('previous element', previousElement);
    // console.log('previous element value', previousElement.value);
  }
  video(){
    this.videoplay = true;
  }
}
